export default __webpack_public_path__ + "static/media/auth-wallpaper-om.412fc5ab.png";